import { GetDeal_deal } from '../graphql/queries/__generated__/GetDeal';
import { DxpDataLayerType } from '../../../../../common/utilities/customDatalayerInterface';
import { NavigationStepLabels } from '../../checkout3/common/enum/NavigationStepLabels';

export interface CommonStepProps {
  label?: NavigationStepLabels;
  pathname: string;
}

export const formatDataLayerDeal = (deal: GetDeal_deal): Partial<DxpDataLayerType> => {
  if (!deal) {
    return null;
  }

  const { model, specPack, exterior, interior } = deal?.car;

  return ({
    model: model?.attributes?.shortname,
    version: specPack?.attributes?.shortname,
    interiorColor: interior?.shortname,
    exteriorColor: exterior?.shortname,
  } as unknown) as Partial<DxpDataLayerType>;
};
